import { useMemo } from "react"
import { isCustomerUser, isReinsurerUser } from "utils"

const useAuthHooks = () => {
  const { isCustomer, isReinsurer } = useMemo(() => {
    return {
      isCustomer: isCustomerUser(),
      isReinsurer: isReinsurerUser(),
    }
  }, [])

  return {
    isCustomer,
    isReinsurer,
  }
}
export default useAuthHooks
